let contextData: any = null;

export const setGlobalUtilContext = (data: any) => {
  contextData = data;
};

export const getGlobalUtilContext = () => contextData;
